module.exports = __webpack_public_path__ + "static/media/dogs-playing-poker.6c1599a7.png";